import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import Tag from "@/components/base/Tag";
import { factChecks, factVerdicts } from "@/mocks/factChecks";

export default function FactCheckStrip() {
  const [active, setActive] = useState<string>("全部");

  const list = active === "全部" ? factChecks : factChecks.filter((item) => item.verdict === active);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Quick Fact Check"
          title="辟谣速查"
          desc="不用读完整篇，也能先拿到一个明确判断。按结论类型筛选，快速定位你关心的那一条信息。"
          action={
            <Link
              to="/fact-check"
              className="inline-flex items-center gap-1.5 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              全部核验
              <i className="ri-arrow-right-line text-base" aria-hidden="true" />
            </Link>
          }
        />

        <div className="mb-6 inline-flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {factVerdicts.map((verdict) => (
            <button
              key={verdict}
              type="button"
              onClick={() => setActive(verdict)}
              className={`cursor-pointer rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                active === verdict
                  ? "bg-primary-500 text-white"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              {verdict}
            </button>
          ))}
        </div>

        {list.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-12 text-center text-sm text-foreground-500">
            该结论类型下暂无条目，试试其他筛选条件。
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {list.slice(0, 6).map((item) => (
              <article
                key={item.id}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center justify-between gap-3">
                  <Tag tone={item.verdict === "谣言" ? "primary" : item.verdict === "属实" ? "secondary" : "neutral"}>
                    {item.verdict}
                  </Tag>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {item.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-500">{item.category}</span>
                  <Link
                    to="/fact-check"
                    className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    核验依据
                    <i className="ri-arrow-right-s-line text-sm" aria-hidden="true" />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}